import { useCallback, useEffect, useState } from 'react';
import eventBus from '@sas/nova-core/eventBus';
import { MessageDialog, useMessageDialogText } from '../../components/MessageDialog';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import bundle from './NovaContent-ContentErrorMessageDialog-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const ContentErrorMessageDialog = props => {
  const {
    CLOSE
  } = useMessageDialogText();
  const [errorQueue, setErrorQueue] = useState([]);
  const [doReOpen, setDoReOpen] = useState(false);
  const localize = useTextLocalizer();
  const onShowError = useCallback((_, eventData) => {
    const data = eventData?.data;
    if (isContentErrorMessageEventData(data)) {
      setErrorQueue(prev => [...prev, data]);
    }
  }, []);
  useEffect(() => {
    eventBus.subscribe(showErrorEvent, onShowError);
    return () => {
      eventBus.unsubscribe(showErrorEvent, onShowError);
    };
  }, [onShowError]);
  const isOpen = doReOpen ? false : errorQueue.length > 0;

  // Queue requests that come in while the dialog is displayed, and use the "doReOpen" state var
  // to trigger a re-open with the next message 500ms after the previous dialog is closed.
  // Without some delay, things don't look quite right when transitioning between dialogs.
  useEffect(() => {
    if (doReOpen) {
      setTimeout(() => {
        setErrorQueue(prev => prev.slice(1));
        setDoReOpen(false);
      }, 500);
    }
  }, [doReOpen]);
  const title = errorQueue[0]?.title ? errorQueue.length > 1 ? localize('TitleQueued.label', {
    title: errorQueue[0].title,
    numberQueued: errorQueue.length.toString()
  }) : errorQueue[0].title : '';

  // default type is 'error'
  const type = errorQueue[0]?.type ? errorQueue[0]?.type : 'error';
  return /*#__PURE__*/_jsx(MessageDialog, {
    testId: props.testId,
    type: type,
    title: title,
    text: errorQueue[0]?.text ?? '',
    detailText: errorQueue[0]?.details?.join('\n') ?? '',
    isOpen: isOpen,
    dismissAction: {
      text: CLOSE,
      onPress: () => {
        if (errorQueue.length > 0) {
          setDoReOpen(true);
        }
      },
      isDefault: true
    }
  });
};
export default ContentErrorMessageDialog;
const showErrorEvent = 'ContentErrorMessageDialog.showErrorEvent';

/**
 * Publish an event that a ContentErrorMessageDialog (or anyone else) can listen to and use to show
 * an error UI.
 * @param errorData Data describing the error message to show.
 */
export const showContentError = errorData => eventBus.publish(showErrorEvent, {
  data: errorData
});

/**
 * Publish an event that a ContentErrorMessageDialog (or anyone else) can listen to and use to show
 * an warning UI.
 * @param errorData Data describing the warning message to show.
 */
export const showContentWarning = errorData => eventBus.publish(showErrorEvent, {
  data: {
    ...errorData,
    type: 'warning'
  }
});

/**
 * Publish an event that a ContentErrorMessageDialog (or anyone else) can listen to and use to show
 * an information UI.
 * @param errorData Data describing the info message to show.
 */
export const showContentInformation = errorData => eventBus.publish(showErrorEvent, {
  data: {
    ...errorData,
    type: 'information'
  }
});
export const isContentErrorMessageEventData = obj => {
  return obj.text && obj.title;
};
//# sourceMappingURL=ContentErrorMessageDialog.js.map